// @flow
/* eslint-disable import/prefer-default-export */

export const MODULE_NAME = 'advertiser';

export const STATUS = Object.freeze({
  ACTIVE: 1,
  INACTIVE: 2,
});



// WEBPACK FOOTER //
// ./src/modules/advertiser/constants.js